import React, { useState, useEffect } from 'react';
import { useSnackbar } from 'notistack';
import { makeStyles } from '@material-ui/core/styles';
import axios from 'axios';
import Header from './Header';
import { DropzoneArea } from 'material-ui-dropzone';
import Button from '@material-ui/core/Button';
import Paper from '@material-ui/core/Paper';
import UploadCompleteModal from '../UploadCompleteModal';
import Progress from '../Progress';
import config, { API } from '../../config';
import { useParams } from 'react-router-dom';

const useStyles = makeStyles((theme) => ({
  root: {
    margin: theme.spacing(5),
  },
}));

export default function MediaUploader({ location }) {
  const classes = useStyles();
  const { enqueueSnackbar } = useSnackbar();
  const [droppedFiles, setDroppedFiles] = useState([]);
  const [uploadStarted, setUploadStarted] = useState(false);
  let [uploadCount, setUploadCount] = useState(0);
  let [progress, setProgress] = useState(1);
  let [modalOpen, setModalOpen] = useState(false);
  const { SFMediaSubmissionID } = useParams();

  // useEffect(() => {
  //   function getSfMediaSubmissionData() {
  //     console.log('[*] getSfMediaSubmissionData');
  //     const reqData = {
  //       mediaSubmissionID: SFMediaSubmissionID,
  //     };
  //     axios
  //       .post(`${API}/v1/getSfMediaSubmission`, reqData)
  //       .then((d) => {
  //         if (d.data.success === true) {
  //           console.log(d.data.SFMediaSubmission);
  //         } else {
  //           console.log('Invalid ID', d.data);
  //         }
  //       })
  //       .catch((err) => {
  //         console.log('[I] getSfMediaSubmission ', err);
  //       });
  //   }

  //   getSfMediaSubmissionData();
  // }, []);

  const handleFileUpload = (files) => {
    console.log('[I] Total files droppedd: ', files.length);
    setDroppedFiles(files);
  };

  const handleClose = (e) => {
    console.log('[I] Complete popup closed. Reset things...');
    //@todo: reset things here in case user uploads things again.
    setModalOpen(false);

    setUploadStarted(false);
    setUploadCount(0);
    setProgress(1);
    setDroppedFiles([]);
    window.location.reload();
  };

  function markUploadComplete() {
    console.log('[*] markUploadComplete');

    const reqData = {
      id: SFMediaSubmissionID,
      type: config.recordTypes.SFMediaSubmissions,
      file_name_list: droppedFiles.map((df) => df.name),
    };
    console.log('[I] reqData: ', reqData);

    axios
      .post(`${API}/v1/upload/complete`, reqData)
      .then((d) => {
        console.log('[I] upload mark done', d);
      })
      .catch((err) => {
        console.log('[I] upload mark failure. ');
      });
  }

  const handleStartUpload = (e) => {
    e.preventDefault();
    console.log('[I] File upload to server started', droppedFiles.length);

    if (droppedFiles.length < 1) {
      enqueueSnackbar('No files selected.', { variant: 'error' });
      return false;
    }
    setUploadStarted(true);

    droppedFiles.forEach((file, index) => {
      console.log('[I] Getting signed url for', index);
      axios
        .post(`${API}/v1/getSignedURL`, {
          SFMediaSubmissionID,
          Filename: file.name,
          ContentType: file.type,
          Action: 'WRITE',
        })
        .then((signedData) => {
          console.log(`Signed URL ${index}:, ${signedData.data.data}`);
          const signedUrl = signedData.data.data;
          axios
            .put(`${signedUrl}`, file, {
              headers: {
                'Content-Type': file.type,
              },
            })
            .then((putResponse) => {
              console.log(`[I] File: uploaded: ${index}:${file.name}`, putResponse);
              setUploadCount(++uploadCount);
              setProgress(Math.ceil((uploadCount * 100) / droppedFiles.length));

              if (uploadCount >= droppedFiles.length) {
                markUploadComplete();
                // setModalOpen(true);
                setTimeout(setModalOpen, 1000, true);
                enqueueSnackbar('File upload completed.', { variant: 'success' });
              }
            })
            .catch((s3PutErr) => {
              console.log('[E] Error uploading to s3', s3PutErr);
              enqueueSnackbar('File upload error.', { variant: 'error' });
            });
        })
        .catch((signingErr) => {
          console.log('[E] Error getting signed url', signingErr);
          enqueueSnackbar('File upload sign error.', { variant: 'error' });
        });
    });
  };

  // function isImageNameRepeated() {
  //   let temp_filenames = droppedFiles.map((df) => df.name);
  //   for (let i = 0; i < temp_filenames.length; i++) {
  //     for (let j = 0; j < temp_filenames.length; j++) {
  //       if (temp_filenames[i] === temp_filenames[j] && i !== j) {
  //         console.log(`${temp_filenames[i]} is duplicate.`);
  //         return temp_filenames[i];
  //       }
  //     }
  //   }
  //   return false;
  // }

  // const checkDuplication = () => {
  //   let repeatedImageName = isImageNameRepeated();
  //   let repeatFileIndex = -1;
  //   if (repeatedImageName) {
  //     repeatFileIndex = droppedFiles.findIndex((df) => df.name === repeatedImageName);
  //   }

  //   if (repeatFileIndex > -1) {
  //     console.log('Repeat Index: ' + repeatFileIndex);
  //     //remove that element from array and get new array.
  //     let UpdatedDroppedFiles = [...droppedFiles.slice(0, repeatFileIndex), ...droppedFiles.slice(repeatFileIndex + 1)];
  //     console.log('updated drop files: ', UpdatedDroppedFiles);
  //     setDroppedFiles(UpdatedDroppedFiles);
  //   }
  // };

  // useEffect(checkDuplication, [droppedFiles]);

  return (
    <div>
      <Header />

      {uploadStarted ? <Progress progress={progress} /> : ''}

      <Paper className={classes.root}>
        <Button
          onClick={handleStartUpload}
          disabled={droppedFiles.length ? false : true}
          variant="contained"
          color="secondary"
          style={{ float: 'right' }}
        >
          Start Upload
        </Button>
        <div>Total Files: {droppedFiles.length}</div>

        <DropzoneArea
          maxFileSize={50000000}
          filesLimit={500}
          multiple
          acceptedFiles={['image/jpeg', 'image/jpg']}
          onChange={handleFileUpload}
          style={{ height: 200, padding: '20px' }}
          previewGridProps={{
            item: {
              lg: '3',
            },
          }}
        />
      </Paper>
      <UploadCompleteModal handleClose={handleClose} imageCount={uploadCount} open={modalOpen} />
    </div>
  );
}
